/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./multimedia-player.vue?vue&type=template&id=571dc99f&scoped=true&"
import script from "./multimedia-player.vue?vue&type=script&lang=ts&"
export * from "./multimedia-player.vue?vue&type=script&lang=ts&"
import style0 from "./multimedia-player.vue?vue&type=style&index=0&id=571dc99f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571dc99f",
  null
  
)

export default component.exports